import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

/** Clave tenant-first: sin tenant no hay consulta (design.md §22.1). */
export function tenantScoped(tenantId: string, ...rest: unknown[]): unknown[] {
  return ['tenant', tenantId, ...rest];
}

/** Normaliza tenantId a string | null para guards de `enabled`. */
export function tenantIdOrNull(value: string | null | undefined): string | null {
  return value ?? null;
}
